import React from 'react'
import _, { isEmpty } from 'lodash'
import { Button, Col, Form, Input, Modal, Row, Select } from 'antd'
import { ButtonEx } from '../../../../styles/button.style'
import { useDeepEffect } from '../../../../utils/hooks'
import { toJsonText, parseJsonText, jsonObjectRule } from '../jsonField'

const JSON_FIELDS = [
  {
    key: 'requiredParams',
    label: 'Required Params (JSON)',
    hint: 'ช่องที่ร้านต้องกรอกตอนเชื่อมต่อ'
  },
  { key: 'staticParams', label: 'Static Params (JSON)' },
  { key: 'mappingParams', label: 'Mapping Params (JSON)' }
]


const INTEGRATION_TYPES = ['USER_CONFIGURED', 'SYSTEM_LEVEL']
const AUTHENTICATION_FLOWS = ['DIRECT_TOKEN', 'OAUTH2_PASSWORD_GRANT']


const withCurrent = (options, current) =>
  current && !options.includes(current) ? [...options, current] : options

const PushTemplateForm = (props) => {
  const { visible, onOk, onCancel, formData, partnerId, form } = props
  const { getFieldDecorator, validateFields } = form
  const isEdit = !_.isEmpty(formData)

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      form.setFieldsValue({
        apiName: formData.apiName,
        apiDescription: formData.apiDescription,
        endpointApi: formData.endpointApi,
        integrationType: formData.integrationType,
        authenticationFlow: formData.authenticationFlow,
        requiredParams: toJsonText(formData.requiredParams),
        staticParams: toJsonText(formData.staticParams),
        mappingParams: toJsonText(formData.mappingParams)
      })
    }
    return () => {
      form.resetFields()
    }
  }, [formData])

  const textOrNull = (value) => (value && value.trim() ? value.trim() : null)

  function onSubmit(e) {
    e.preventDefault()
    validateFields((err, values) => {
      if (err) return
      onOk({
        partnerId: Number(partnerId),
        apiName: values.apiName.trim(),
        apiDescription: textOrNull(values.apiDescription),
        endpointApi: values.endpointApi.trim(),
        integrationType: textOrNull(values.integrationType),
        authenticationFlow: textOrNull(values.authenticationFlow),
        // ซ่อนจากฟอร์ม แต่ส่งค่าเดิมกลับไป ไม่ให้ค่าใน DB ถูกล้าง
        credentialSource: formData.credentialSource || null,
        connectionTokenEndpoint: formData.connectionTokenEndpoint || null,
        requiredParams: parseJsonText(values.requiredParams),
        staticParams: parseJsonText(values.staticParams),
        mappingParams: parseJsonText(values.mappingParams)
      })
    })
  }

  return (
    <Modal
      title={`${isEdit ? 'แก้ไข' : 'สร้าง'} Push Template`}
      visible={visible}
      footer={null}
      onCancel={onCancel}
      width={720}>
      <Form form={form} onSubmit={onSubmit} layout="vertical">
        <Row gutter={8}>
          <Col span={12}>
            <Form.Item label="API Name">
              {getFieldDecorator('apiName', {
                rules: [{ required: true, message: 'กรุณากรอก API Name' }]
              })(<Input />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Integration Type">
              {getFieldDecorator('integrationType', {
                initialValue: 'USER_CONFIGURED'
              })(
                <Select>
                  {withCurrent(INTEGRATION_TYPES, formData.integrationType).map(
                    (value) => (
                      <Select.Option key={value} value={value}>
                        {value}
                      </Select.Option>
                    )
                  )}
                </Select>
              )}
            </Form.Item>
          </Col>
        </Row>

        <Form.Item label="คำอธิบาย">
          {getFieldDecorator('apiDescription')(<Input.TextArea rows={2} />)}
        </Form.Item>

        <Form.Item label="Endpoint API" extra="path ที่ใช้ส่งข้อมูลไปยัง partner">
          {getFieldDecorator('endpointApi', {
            rules: [
              {
                required: true,
                whitespace: true,
                message: 'กรุณากรอก Endpoint API'
              }
            ]
          })(<Input placeholder="api/Default/Associate" />)}
        </Form.Item>

        <Row gutter={8}>
          <Col span={12}>
            <Form.Item label="Authentication Flow">
              {getFieldDecorator('authenticationFlow')(
                <Select allowClear placeholder="เลือก">
                  {withCurrent(
                    AUTHENTICATION_FLOWS,
                    formData.authenticationFlow
                  ).map((value) => (
                    <Select.Option key={value} value={value}>
                      {value}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
        </Row>

        {JSON_FIELDS.map(({ key, label, hint }) => (
          <Form.Item key={key} label={label} extra={hint}>
            {getFieldDecorator(key, { rules: [jsonObjectRule] })(
              <Input.TextArea
                rows={4}
                style={{ fontFamily: 'monospace' }}
                placeholder='{"key": "value"}'
              />
            )}
          </Form.Item>
        ))}

        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              บันทึก
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

export default Form.create({ name: 'PushTemplateForm' })(PushTemplateForm)
